import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { Provider } from 'react-redux'
import { store } from './store'
import { BrokersProvider } from './providers/brokerProvider'
import { FormProvider } from './providers/formProvider'

const formAddr = process.env.REACT_APP_FORM_ADDR ?? 'http://localhost:4242'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
	<BrokersProvider baseUrl={formAddr}>
		<FormProvider baseUrl={formAddr}>
			<Provider store={store}>
				<React.StrictMode>
					<App />
				</React.StrictMode>
			</Provider>
		</FormProvider>
	</BrokersProvider>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
